import { Col } from 'antd';
import { ColorsStoryboard } from './Colors';

import { Box, Input, InputDate, InputNumber, InputSearch, Pagination, Switch, Text } from 'basic-ui-lib';
import styled from 'styled-components';
import { TextStoryboard } from './Text';
import { IconsStoryBoard } from './Icons';
import { ButtonStoryBoard } from './Button';
import CheckboxGroup from 'basic-ui-lib/components/Checkbox/CheckboxGroup';
import { RadioButtons } from 'basic-ui-lib/components/RadioButtons';
import InputPhone from 'basic-ui-lib/components/Input/InputPhone';
import TableStoryBoard from './Table';

const StoryboardPage = () => {
  return (
    <Container>
      <Col>
        <Text title_h1 left>
          Colors
        </Text>
        <ColorsStoryboard />
      </Col>
      <Col>
        <Text title_h1 left>
          Text
        </Text>
        <TextStoryboard />
      </Col>
      <Col>
        <Text title_h1 left>
          Icons
        </Text>
        <IconsStoryBoard />
      </Col>
      <Col>
        <Text title_h1 left>
          Button
        </Text>
        <ButtonStoryBoard />
      </Col>
      <Col>
        <Text title_h1 left>
          Check box
        </Text>
        <CheckboxGroup
          options={[
            { label: 'Option 1', value: 'option1' },
            { label: 'Option 2', value: 'option2' },
            { label: 'Option 3', value: 'option3' },
          ]}
          values={['option1', 'option3']}
          onChange={(selected) => console.log('Selected values:', selected)}
        />
      </Col>
      <Col>
        <Text title_h1 left>
          Radio Button
        </Text>
        <RadioButtons
          options={[
            { label: 'Option 1', value: 'option1' },
            { label: 'Option 2', value: 'option2' },
            { label: 'Option 3', value: 'option3' },
          ]}
          value='option1'
          onChange={(selected) => console.log('Selected values:', selected)}
        />
      </Col>
      <Col>
        <Text title_h1 left>
          Switch
        </Text>
        <Box display='flex' gap={10}>
          <Switch />
          <Switch value={true} />
        </Box>
      </Col>
      <Col>
        <Text title_h1 left>
          Table
        </Text>
        <TableStoryBoard />
      </Col>
      <Col>
        <Text title_h1 left>
          Pagination
        </Text>
        <Pagination
          totalItems={100}
          currentPage={1}
          onPageChange={(page) => console.log('Current page:', page)}
          labelDisplay='screens'
          itemsPerPage={10}
          showRowPerPage
          maxVisiblePages={3}
        />
      </Col>
      <Col>
        <Text title_h1 left>
          Input
        </Text>
        <Box display='flex' flexDirection='column' gap={20} width={300}>
          <Input value='test' />
          <InputPhone value='0866675676' />
          <InputDate />
          <InputNumber value={123} />
          <InputSearch />
        </Box>
      </Col>
    </Container>
  );
};

export default StoryboardPage;

const Container = styled.div`
  padding: 20px;
  background-color: #f5f5f5;
`;
